module.exports = __webpack_public_path__ + "static/media/arraial-do-cabo-rj.ecc6866e.jpg";